import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  // Specialties
  Specialties,
  // Provider Specialties
  GetProviderSpecialty,
  CreateProviderSpecialty,
  UpdateProviderSpecialty,
  DeleteProviderSpecialty,
  GetProviderSpecialtyById,
  // CredentialsNT
  GetCredentialsNT,
  CreateCredentialsNT,
  UpdateCredentialsNT,
  DeleteCredentialsNT,
  GetCredentialsNTStates,
  GetCredentialsNTSpecialties,
  // Visit Schedule
  GetSchedule,
  GetScheduleById,
  CreateSchedule,
  UpdateSchedule,
  UpdateScheduleRealized,
  DeleteSchedule,
} from '../../../store/actions';

/**
 * CredentialsNTInjection is responsible for injecting the methods about store of credentialsNT, specialties, provider specialties and visit schedule.
 *
 * @return
 *
 *
 *
 */
export const CredentialsNTInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   *
   * @CredentialsNT
   */
  const getCredentialsNT = useCallback(
    async (status, params) => {
      dispatch(GetCredentialsNT(status, params));
    },
    [dispatch]
  );

  const createCredentialsNT = useCallback(
    async (data) => {
      dispatch(CreateCredentialsNT(data));
    },
    [dispatch]
  );

  const updateCredentialsNT = useCallback(
    async (data) => {
      dispatch(UpdateCredentialsNT(data));
    },
    [dispatch]
  );

  const deleteCredentialsNT = useCallback(async (id) => {
    dispatch(DeleteCredentialsNT(id));
  }, []);

  const getCredentialsNTStates = useCallback(async () => {
    dispatch(GetCredentialsNTStates());
  }, [dispatch]);

  const getCredentialsNTSpecialties = useCallback(
    async (params) => {
      dispatch(GetCredentialsNTSpecialties(params));
    },
    [dispatch]
  );
  /**
   *
   *
   * @Specialties
   */
  const getSpecialties = async () => {
    dispatch(Specialties());
  };
  /**
   *
   *
   * @ProviderSpecialties
   */
  const getProviderSpecialty = useCallback(
    (id) => {
      dispatch(GetProviderSpecialty(id));
    },
    [dispatch]
  );

  const getProviderSpecialtyById = useCallback(
    (id) => {
      dispatch(GetProviderSpecialtyById(id));
    },
    [dispatch]
  );

  const createProviderSpecialty = (data) => {
    dispatch(CreateProviderSpecialty(data));
  };

  const updateProviderSpecialty = (id, data) => {
    dispatch(UpdateProviderSpecialty(id, data));
  };

  const deleteProviderSpecialty = (id) => {
    dispatch(DeleteProviderSpecialty(id));
  };
  /**
   *
   *
   * @VisitSchedule
   */
  const getSchedule = (id) => {
    dispatch(GetSchedule(id));
  };

  const getScheduleById = useCallback(
    (id) => {
      dispatch(GetScheduleById(id));
    },
    [dispatch]
  );

  const createSchedule = (data) => {
    dispatch(CreateSchedule(data));
  };

  const updateSchedule = (id, data) => {
    dispatch(UpdateSchedule(id, data));
  };

  const updateScheduleRealized = (id, data) => {
    dispatch(UpdateScheduleRealized(id, data));
  };

  const deleteSchedule = (id) => {
    dispatch(DeleteSchedule(id));
  };

  /**
   * @variables
   *
   * error: string
   * loading: boolean
   * success: string
   */
  const {
    states,
    specialties_credentialsNT,
    specialties,
    credentialsNT,
    providerSpecialty,
    error_credentialsNT,
    success_credentialsNT,
    success_providerSpecialty,
    schedule,
    scheduleById,
    error_schedule,
    success_schedule,
    successDelete
  } = useSelector((state) => ({
    // CredentialsNT
    error_credentialsNT: state.CredentialsNT.error,
    credentialsNT: state.CredentialsNT.credentialsNT,
    success_credentialsNT: state.CredentialsNT.success,
    successDelete: state.CredentialsNT.successDelete,
    states: state.CredentialsNT.states,
    specialties_credentialsNT: state.CredentialsNT.specialties,
    // Specialties
    specialties: state.Specialties.specialties,
    // Provider Specialties
    providerSpecialty: state.ProviderSpecialty.providerSpecialty,
    success_providerSpecialty: state.ProviderSpecialty.success,
    // Visit Schedule
    schedule: state.Schedule.schedule,
    scheduleById: state.Schedule.scheduleById,
    error_schedule: state.Schedule.error,
    success_schedule: state.Schedule.success,
  }));

  return {
    // States
    credentialsNT,
    providerSpecialty,
    error_credentialsNT,
    success_credentialsNT,
    success_providerSpecialty,
    schedule,
    scheduleById,
    successDelete,
    error_schedule,
    success_schedule,
    states,
    specialties_credentialsNT,
    specialties,
    // Dispatchs
    getSpecialties,
    getCredentialsNT,
    createCredentialsNT,
    updateCredentialsNT,
    deleteCredentialsNT,
    getCredentialsNTStates,
    getCredentialsNTSpecialties,
    getProviderSpecialty,
    getProviderSpecialtyById,
    createProviderSpecialty,
    updateProviderSpecialty,
    deleteProviderSpecialty,
    getSchedule,
    getScheduleById,
    createSchedule,
    updateSchedule,
    updateScheduleRealized,
    deleteSchedule,
  };
};
